module.exports = __webpack_public_path__ + "img/Afghanistan.549f7154.svg";